import type { AxiosRequestInterceptors, AxiosRequest, AxiosResponse } from '@fanghub/tool-request'
import { ElLoading } from 'element-plus'
import type { LoadingInstance } from 'element-plus'

let loadingInstance: LoadingInstance

export const loadingHandler: AxiosRequestInterceptors<AxiosRequest, AxiosResponse> = {
    // 请求拦截：添加 Token 到请求头
    requestInterceptor: (config: AxiosRequest) => {
        const { needLoading } = config
        if (needLoading) {
            if (loadingInstance) {
                loadingInstance.close()
            }
            loadingInstance = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        }
        return config
    },
    // 请求错误拦截
    requestInterceptorCatch: error => {
        if (loadingInstance) {
            loadingInstance.close()
        }
        return Promise.reject(error)
    },
    // 响应拦截：统一处理后端返回格式
    responseInterceptor: (response: AxiosResponse) => {
        if (loadingInstance) {
            loadingInstance.close()
        }
        return response
    },
    // 响应错误拦截
    responseInterceptorCatch: error => {
        if (loadingInstance) {
            loadingInstance.close()
        }
        return Promise.reject(error)
    }
}
